import * as React from 'react';
const RialWhiteIso = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Diseno Original"
    viewBox="0 0 1090 645"
    {...props}
  >
    <path
      d="M999.67 84.7H885.45c-18.96 0-34.33 15.37-34.33 34.33v85.13c0 18.96-15.37 34.33-34.33 34.33H606.93c-18.96 0-34.33-15.37-34.33-34.33v-85.13c0-18.96-15.37-34.33-34.33-34.33H270.24c-18.96 0-34.33 15.37-34.33 34.33v85.13c0 18.96-15.37 34.33-34.33 34.33h-85.13c-18.96 0-34.33 15.37-34.33 34.33v114.54c0 18.96 15.37 34.33 34.33 34.33h114.22c18.96 0 34.33-15.37 34.33-34.33V301.9c0-18.96 15.37-34.33 34.33-34.33h209.86c18.96 0 34.33 15.37 34.33 34.33v238.94c0 18.96 15.37 34.33 34.33 34.33h114.22c18.96 0 34.33-15.37 34.33-34.33v-85.13c0-18.96 15.37-34.33 34.33-34.33h85.13c18.96 0 34.33-15.37 34.33-34.33v-85.13c0-18.96 15.37-34.33 34.33-34.33h85.14c18.96 0 34.33-15.37 34.33-34.33V119.04c0-18.96-15.37-34.33-34.33-34.33Z"
      style={{
        fill: '#ffffff',
        strokeWidth: 0,
      }}
    />
  </svg>
);
export default RialWhiteIso;
